var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.save}},[_c('v-img',{attrs:{"src":_vm.icon,"width":"360"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }